import { createReducer, on } from '@ngrx/store';
import { createInitialServiceState } from './service.state';
import * as actions from '../service/service.actions';
import { ReducerFactory } from '../../../shared/store/common/reducer.factory';

const factory = new ReducerFactory(actions as any);

export const serviceReducer = createReducer(
    createInitialServiceState(),
    on(
        actions.setWork,
        actions.setWorkRecordDate,
        actions.setService,
        (state, newState) => ({ ...state, ...newState }),
    ),
);
